import { useEffect, useState } from 'react';
import { useIVASetChatStatus, useIVAChatStatus } from '../IVAChatStatusProvider';
export function useSetChatStatus(historyLoaded, hasHistory, isOpen, isIVAAvailable) {
    const [isChatStatusInitialized, setIsChatStatusInitialized] = useState(false);
    const { initChatStatus } = useIVASetChatStatus();
    const chatStatus = useIVAChatStatus();
    useEffect(() => {
        if (!isChatStatusInitialized && historyLoaded) {
            setIsChatStatusInitialized(true);
            initChatStatus(Object.assign(Object.assign({}, chatStatus), { isOpen: !!isOpen, isAvailable: !!isIVAAvailable, isActive: hasHistory }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [historyLoaded]);
}
